import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { StateContext } from '../../contexts/stateContext';
import { _getAdminUsersList } from '../utilsAdmin';
import { ListAvatars } from '../Lists/ListAvatars';
import { ListAvatarsLayout } from '../Lists/ListAvatarsLayout';
import { SocialFilters, filterArrayByStats, matchesStatsFilter } from '../UiKit/SocialFilters';
import { Preloader, Preloader0 } from '../UiKit/kit';
import { AdminMenu } from './AdminMenu';

export function AdminNetwork() {
  const context = { ...useContext(LangContext), ...useContext(StateContext) };
  const $ui = context.$ui || ((key) => key);

  const [users, setUsers] = useState([]);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('types');
  const [statsFilter, setStatsFilter] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const data = await _getAdminUsersList();
        if (cancelled) return;
        setUsers(Array.isArray(data) ? data.filter(Boolean) : []);
        setReady(true);
      } catch (err) {
        if (cancelled) return;
        setError(err?.message || 'Failed to load users');
        setReady(true);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  const handleStatsSelect = useCallback((match) => {
    setStatsFilter((prev) => {
      if (match.profile) {
        const sameProfile = prev?.type === match.type
          && prev?.profile?.[0] === match.profile[0]
          && prev?.profile?.[1] === match.profile[1];
        if (sameProfile) return { type: match.type };
        return { type: match.type, profile: match.profile };
      }
      if (match.type) {
        if (prev?.type === match.type && !match.profile) return null;
        return { type: match.type };
      }
      if (prev && matchesStatsFilter(prev, match)) return null;
      return { ...match };
    });
  }, []);

  const clearStatsFilter = useCallback(() => setStatsFilter(null), []);

  const toggleStatsMode = useCallback(() => {
    setFilter((prev) => (prev === 'types' ? 'profiles' : 'types'));
    setStatsFilter(null);
  }, []);

  const filteredUsers = useMemo(
    () => (statsFilter ? filterArrayByStats(users, statsFilter) : users),
    [users, statsFilter]
  );

  const quantity = filteredUsers.length;

  return (
    <div className="b b--admin">
      <AdminMenu active="network" />
      <div className="admin_content" style={{ padding: '0 0 6em' }}>
        {!ready && (
          <Preloader0 className="x_choose_preloader0" height="16em" width="100%">
            <Preloader width={48} height={48} />
          </Preloader0>
        )}

        {ready && error && (
          <div style={{ padding: '2em', opacity: 0.6 }}>{error}</div>
        )}

        {ready && !error && (
          <ListAvatarsLayout
            icon="group"
            title={$ui('people_people')}
            listId="admin-network"
            quantity={users.length}
            className="v"
            fullSrceen
            addLeft={(
              <SocialFilters
                type={filter}
                array={users}
                onSelect={handleStatsSelect}
                activeFilter={statsFilter}
                onClear={clearStatsFilter}
                onToggleMode={toggleStatsMode}
              />
            )}
          >
            <ListAvatars
              listId="admin-network"
              quantity={quantity}
              array={filteredUsers}
              actions={['share']}
              celeb
              fullSrceen
              showIndex
              paginate={context.state.paginate}
            />
          </ListAvatarsLayout>
        )}
      </div>
    </div>
  );
}
